<ng-container *transloco="let t">
  <div infinite-scroll
       [infiniteScrollDistance]="1"
       (scrolled)="scrolled.emit()"
       class="row row-cols-1">
    @for (item of userEvents; track item.competitor?.id) {
      <div class="py-10">
        <app-user-event-grid-item
          [userEvent]="item"
          [languages]="languages"
          [type]="type"
          [leftButtonKey]="leftButtonKey"
          [rightButtonKey]="rightButtonKey"
          [showLeftActionButton]="showLeftActionButton"
          [showRightActionButton]="showRightActionButton"
          (onLeftButtonClickCallback)="onLeftButtonClickCallback.emit(item)"
          (onRightButtonClickCallback)="onRightButtonClickCallback.emit(item)"/>
      </div>
    }
  </div>
</ng-container>
